export const scrollToTopPageFN = () => {
  window.scrollTo(0, 0);
};
